var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"navbar-item",on:{"click":_setup.toggleNotificationModal}},[(_setup.props.showLabel)?_c('span',[_vm._v(_vm._s(_vm.$t('notification.notifications')))]):_vm._e(),_vm._v(" "),_c(_setup.NeoIcon,{staticClass:"icon",attrs:{"icon":"bell","pack":"far"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }